/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { Loader, withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { getApdLobQuoteUrl } from '@xengage/gw-portals-url-js';
import { JobUtil } from '@xengage/gw-portals-util-js';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import {
    JobService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import UnderwritingComponent from '../../Components/UnderwritingComponent/UnderwritingComponent';
import gatewayMessages from '../../gateway.messages';
import messages from './Summary.messages';
import metadata from './Summary.metadata.json5';
import styles from './Summary.module.scss';

class QuoteDetailsSummary extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            quoteDetailsData: PropTypes.shape({
                getQuoteSummaryCount: PropTypes.func,
                jobNumber: PropTypes.string.isRequired,
                loadQuoteSummary: PropTypes.shape({}),
                updateJobSummary: PropTypes.func,
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }).isRequired,
    };

    state = {
        showisContinueTransactionButton: false,
        canWithdraw: false,
        isLoading: true,
    };

    componentDidMount = () => {
        this.canWithdraw();
        this.getShowisContinueTransaction();
    };

    getShowisContinueTransaction = async () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'createsubmission',
        };
        const showisContinueTransactionButton =
            await UserService.hasUserSystemPermission(
                permissionDTO,
                authHeader
            );
        this.setState({ showisContinueTransactionButton, isLoading: false });
    };

    canWithdraw = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
        } = this.props;
        if (!_.isEmpty(submission)) {
            const translator = this.context;
            if (
                submission.status !==
                    translator('typekey.PolicyPeriodStatus.Bound') &&
                !submission.policy.issued &&
                !submission.closeDate
            ) {
                this.setState({ canWithdraw: true });
            }
        }
    };

    onContinueTransaction = () => {
        const { lobQuoteURL } = appConfig;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
            history,
            authUserData
        } = this.props;
        const productCode = _.get(submission, 'productCode');
        const postalCode = _.get(
            submission,
            'policy.account.accountHolder.primaryAddress.postalCode'
        );
        if (submission.jobNumber > 0) {
            // US26481 switch the residential wizard by company
            const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
            const isHomeowners = productCode === 'Homeowners';
            const quoteURL = isTFPA && isHomeowners ? lobQuoteURL['HomeownersTFPA'] : lobQuoteURL[productCode];
            if (!_.isNil(quoteURL)) {
                const nextLocation = {
                    quoteentry: {
                        postalCode: postalCode,
                        quoteID: submission.jobNumber,
                    },
                    productCode,
                };
                history.push(quoteURL, nextLocation);
            } else if (!_.isNil(getApdLobQuoteUrl(productCode))) {
                const nextLocation = {
                    productCode,
                    accountId: submission.policy.account.publicID,
                    jobId: submission.publicID,
                };
                history.push(getApdLobQuoteUrl(productCode), nextLocation);
            } else {
                JobUtil.openJobInXCenter(submission.jobNumber);
            }
        }
    };

    onWithdrawTransaction = () => {
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
            authHeader,
            modalContext,
        } = this.props;
        modalContext
            .showConfirm({
                title: messages.withdrawJob,
                message: `${translator(messages.sureWithDrawQuote)} ${
                    submission.jobNumber
                }?`,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.withdraw,
                cancelButtonText: messages.cancel,
            })
            .then(results => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }
                JobService.withdrawJobByJobNumber(
                    submission.jobNumber,
                    authHeader
                ).then(
                    () => {
                        this.updateWithDrawQuote('Withdrawn', submission);
                    },
                    (e) => { // US26332 - Common Quote - Deactivated Producer Code
                        if (e.appErrorCode === 11001) {
                            modalContext.showAlert({
                                    title: gatewayMessages.modalError,
                                    message: messages.errorDescription,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.cancelModel,
                                }).catch(_.noop);
                        } else {
                            modalContext.showAlert({
                                title: gatewayMessages.modalError,
                                message: messages.failedWithdrawSubmission,
                                status: 'error',
                                icon: 'mi-error-outline',
                                confirmButtonText: commonMessages.ok,
                            }).catch(_.noop);
                        }
                    }
                );
            }, _.noop);
    };

    // DE16973
    hasUwIssues = uwIssues => {
        return uwIssues?.filter(uw=>(uw.currentBlockingPoint!=='NonBlocking' 
            || (uw.currentBlockingPoint==='NonBlocking' && uw.hasApprovalOrRejection))).length > 0;
    };

    // DE18238
    showAppropriateBoxesTfpa = (submission, associationName) => {
        return (this.hasUwIssues(submission.underwritingIssues) && ((submission?.underwritingIssues.some(
            issue =>
                issue.isPolicyHoldTWIA && !issue.hasApprovalOrRejection) && associationName === 'tfpa') || 
            (submission?.underwritingIssues.every(
                issue =>
                    issue.hasApprovalOrRejection) && associationName === 'tfpa'))) ||
            !this.hasUwIssues(submission.underwritingIssues)&& (associationName === 'tfpa')
    }

    getNotificationContent = () => {
        const translator = this.context;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            }, authUserData } = this.props;
        const { showisContinueTransactionButton } = this.state;
        const content = {};
        const associationName = _.get(authUserData, 'associationName_TWIA');
        // DE18087
        if (
            submission &&
            !['Bound', 'Quoted', 'Withdrawn', 'Submitted_Ext', 'NotTaken', 'Declined', 'Expired'].includes(submission.statusCode) &&
            (!this.hasUwIssues(submission.underwritingIssues) || (this.showAppropriateBoxesTfpa(submission,associationName))
        )) {
            content.infoMessageTitle = associationName === 'tfpa' ?
                translator(messages.quoteSuccessfullyStarted) :
                translator(messages.quoteSuccessfullyStartedTwia)
            content.infoMessageDescription = showisContinueTransactionButton
                ? translator(messages.continiueQuoteQizard)
                : translator(messages.mayWithdrawQuote);
        }
        // DE17978
        if (
            submission &&
            submission.statusCode === 'Quoted' &&
            (!this.hasUwIssues(submission.underwritingIssues) || this.showAppropriateBoxesTfpa(submission,associationName))
        ) {
            content.infoMessageTitle = associationName === 'tfpa' ?
                translator(messages.premiumQuoteCalculated) :
                translator(messages.premiumQuoteCalculatedTWIA)
            content.infoMessageDescription = showisContinueTransactionButton
                ? translator(messages.changeQuoteWizardToBind)
                : translator(messages.mayWithdrawQuote);
        }
        if (
            submission &&
            submission.statusCode === 'Submitted_Ext' && ((!this.hasUwIssues(submission.underwritingIssues) 
            &&  associationName === 'tfpa') ||  associationName !== 'tfpa')
        ) {
            content.infoMessageTitle =
                translator(messages.quoteOfferSubmitted)
            content.infoMessageDescription = translator(messages.quoteOfferSubmittedViewDocs);
        }
        if (
            submission &&
            submission.statusCode === 'NotTaken'
        ) {
            content.infoMessageTitle =
                translator(messages.quoteNotTaken)
        }
        if (
            submission &&
            submission.statusCode === 'Expired'
        ) {
            content.infoMessageTitle =
                translator(messages.expiredQuoteMessage)
        }
        if (
            submission &&
            submission.statusCode === 'Declined' &&
            !this.hasUwIssues(submission.underwritingIssues)
        ) {
            content.infoMessageTitle =
                translator(messages.quoteDeclinedMessage)
            content.infoMessageDescription = submission.declineReason_TWIA;
        }
        if (submission && submission.statusCode === 'Withdrawn') {
            content.infoMessageTitle = translator(
                messages.thisQuoteHasBeenWithDrawn
            );
            content.infoMessageDescription = '';
        }
        if (submission && submission.statusCode === 'Bound') {
            content.infoMessageTitle = translator(messages.quoteHasBeenBound);
            content.infoMessageDescription = '';
        }
        return {
            infoMessageTitle: content.infoMessageTitle,
            infoMessageDescription: content.infoMessageDescription,
            withDrawContent: translator(messages.withdrawQuote),
            continueContent: translator(messages.continueQuote),
        };
    };

    getSubmissionToProceed = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },authUserData
        } = this.props;
        const { canWithdraw, showisContinueTransactionButton } = this.state;
        const associationName = _.get(authUserData, 'associationName_TWIA');
        if (
            submission &&
            (submission.statusCode === 'Withdrawn' ||
                submission.statusCode === 'Bound')
        ) {
            return {
                isContinueTransaction: false,
                isWithdrawTransaction: false,
            };
        }
        // DE18101
        // DE18104,DE18106,DE18154,DE18155,DE18156,DE18157
        // DE18905 UAT - TFPA - Can't continue quote in Draft status
        return {
            isContinueTransaction:
                (showisContinueTransactionButton || associationName === 'tfpa') &&
                canWithdraw &&
                ((!submission.isEditLocked) || (this.showAppropriateBoxesTfpa(submission,associationName) 
                && (submission.statusCode === 'Quoted' || submission.statusCode === 'Draft') && (submission.isEditLocked))),
            isWithdrawTransaction: canWithdraw,
        };
    };

    getPolicyLinkVisible = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
        } = this.props;
        const policyNumber = _.get(
            submission,
            'policy.latestPeriod.policyNumber'
        );
        if (policyNumber) {
            return policyNumber !== 'Unassigned';
        }
        return false;
    };

    redirectToPolicy = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
        } = this.props;
        const policyNumber = _.get(
            submission,
            'policy.latestPeriod.policyNumber'
        );
        return (
            <Link
                to={`/policies/${policyNumber}/summary`}
                className={styles.removeLinkStyle}
            >
                {policyNumber}
            </Link>
        );
    };

    getJobStatus = job => {
        const translator = this.context;
        if (job.policy) {
            if (job.policy.issued) {
                return translator(gatewayMessages.issued);
            }
            if (job.status === 'Not-taken') {
                return translator(gatewayMessages.notTaken);
            }
        }
        return job.status;
    };

    getStatusInfo = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
        } = this.props;
        const translator = this.context;
        const submissionStatus = this.getJobStatus(submission);
        if (
            submissionStatus.toLowerCase() === 'bound' &&
            submission.policy.issued
        ) {
            return translator('gateway.directives.JobSummary.Issued');
        }
        return submissionStatus;
    };

    updateWithDrawQuote = (jobStatusCode, submission) => {
        const translator = this.context;
        const status = translator({
            id: `typekey.PolicyPeriodStatus.${jobStatusCode}`,
            defaultMessage: jobStatusCode,
        });
        _.set(submission, 'status', status);
        _.set(submission, 'statusCode', jobStatusCode);
        this.updateJobSummary(submission);
    };

    updateJobSummary = submission => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { updateJobSummary, getQuoteSummaryCount },
            },
        } = this.props;

        if (updateJobSummary) {
            updateJobSummary(submission);
        }
        if (getQuoteSummaryCount) {
            getQuoteSummaryCount();
        }
    };

    getAddressLineFields = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            },
        } = this.props;
        // DE16931
        const addressStyle = { margin: 0, padding: 0 };

        // DE16932
        if (submission?.policy?.lobs?.homeOwners_tfpa?.dwellingDTO?.address) {
            return (
                <div>
                    <p style={addressStyle}>{submission.policy.lobs.homeOwners_tfpa.dwellingDTO.address.addressLine1}</p>
                    <p style={addressStyle}>{submission.policy.lobs.homeOwners_tfpa.dwellingDTO.address.city}</p>
                    <p style={addressStyle}>{submission.policy.lobs.homeOwners_tfpa.dwellingDTO.address.state}</p>
                    <p>{submission.policy.lobs.homeOwners_tfpa.dwellingDTO.address.postalCode}</p>
                </div>
            );
        } 
        if (submission?.policy?.account?.accountHolder?.primaryAddress) {
            return (
                <div>
                    <p style={addressStyle}>{submission.policy.account.accountHolder.primaryAddress.addressLine1}</p>
                    <p style={addressStyle}>{submission.policy.account.accountHolder.primaryAddress.city}</p>
                    <p style={addressStyle}>{submission.policy.account.accountHolder.primaryAddress.state}</p>
                    <p style={addressStyle}>{submission.policy.account.accountHolder.primaryAddress.postalCode}</p>
                </div>
            );
        }

        return '';
    };

    // DE16944
    checkVisibleStatus = (submission, associationName) => {
        if (!submission || !submission.statusCode || !submission.policy?.latestPeriod) {
            return false;
        }
     
        const statusCodes = ['Quoted', 'Submitted_Ext', 'NotTaken', 'Declined', 'Expired', 'Withdrawn'];
     
        if (associationName === 'tfpa' && submission?.policy?.latestPeriod?.totalPremium?.amount !== 0) {
            return statusCodes.includes(submission.statusCode);
        }
     
        if (associationName === 'twia' && submission?.policy?.latestPeriod?.totalAnnualPremium_TWIA?.amount !== 0) {
            return statusCodes.includes(submission.statusCode);
        }
     
        return false;
    };

    render() {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadQuoteSummary: submission },
            }, authUserData
        } = this.props;

        const { isLoading } = this.state;
        const associationName = _.get(authUserData, 'associationName_TWIA');
        if (_.isEmpty(submission)) {
            return <Loader loaded={!isLoading} />;
        }
        const overrides = {
            quoteNotification: {
                notificationContent: this.getNotificationContent(),
                transactionVisibleActions: this.getSubmissionToProceed(),
                associationName, submission
            },
            quoteNotificationOffer: {
                visible: submission.statusCode === 'Submitted_Ext'
            },
            underwritingTable: {
                job: submission,
                continueJob: this.getSubmissionToProceed(),
                jobService: SubmissionService,
                onUpdateJobSummary: this.updateJobSummary,
            },
            policyInfoLink: {
                visible: this.getPolicyLinkVisible(),
                value: this.redirectToPolicy(),
            },
            summaryStatusDataId : {
                value: submission.status === 'Not-taken' ? 'Not Taken' : submission.status // DE16940
            },
            totalPremiumId: {
                visible: this.checkVisibleStatus(submission, associationName) && associationName === 'tfpa'
            },
            totalPremiumIdTwia: {
                visible: this.checkVisibleStatus(submission, associationName) && associationName === 'twia'
            },
            taxesAndFeesId: {
                visible: this.checkVisibleStatus(submission, associationName) && associationName === 'tfpa'
            },
            totalCostId: {
                visible: this.checkVisibleStatus(submission, associationName) && associationName === 'tfpa'
            },
            offerExpiryDate: {
                value: associationName === 'tfpa' ? submission.offerExpirationDate_Ext : submission.offerExpirtationDate_TWIA,
                visible: submission.statusCode === 'Submitted_Ext',
            },
            propetyInsuedTitle: {
                visible: associationName === 'tfpa'
            },
            addressField: {
                value: this.getAddressLineFields(),
                visible: associationName === 'tfpa'
            },
            producerCodeOfRecordOrgId: {
                value: `${_.get(
                    submission,
                    'policy.latestPeriod.producerCodeOfRecordOrg'
                )} (${_.get(
                    submission,
                    'policy.latestPeriod.producerCodeOfRecord'
                )})`,
            },
            producerOfServiceId: {
                value: `${_.get(
                    submission,
                    'policy.latestPeriod.producerCodeOfServiceOrg'
                )} (${_.get(
                    submission,
                    'policy.latestPeriod.producerCodeOfService'
                )})`,
            },
            summaryStatusdDataId: {
                value: this.getStatusInfo(),
            },
        };
        const resolvers = {
            resolveComponentMap: {
                underwritingcomponent: UnderwritingComponent,
            },
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                onContinueTransaction: this.onContinueTransaction,
                onWithdrawTransaction: this.onWithdrawTransaction,
                redirectToPolicy: this.redirectToPolicy,
            },
        };
        const readValue = (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                submission,
                id,
                path,
                overrides
            );
        };
        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submission}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
            />
        );
    }
}

export default withAuthenticationContext(withModalContext(QuoteDetailsSummary));
